import { useMemo } from 'react';

import ELEMENT from 'common/element';
import { TOKEN_TYPE } from 'common/util/filter/types';

import Toolbar from 'components/common/Toolbar/Toolbar';
import Button, { ButtonVariant } from 'components/common/Button/Button';
import FilterInput from 'components/search/FilterInput';

import './LiveTailToolbar.scss';

type LiveTailToolbarProps = {
  performRefetch: () => void;
};

/**
 * TODO: get correct filter when Search button is clicked
 * Live Tail toolbar that handles changing filters.
 */
function LiveTailToolbar({ performRefetch }: LiveTailToolbarProps): JSX.Element {
  const excludeTypes = useMemo(() => [TOKEN_TYPE.COMMAND, TOKEN_TYPE.FUNCTION], []);

  const items = [
    <FilterInput onEnter={(): void => performRefetch()} excludeTypes={excludeTypes} />,
    <Button
      className="SearchToolbar__Button"
      onClick={(): void => performRefetch()}
      variant={ButtonVariant.PRIMARY}
      testId={ELEMENT.liveTailSearchButton}
    >
      Search
    </Button>,
  ];

  return <Toolbar className="LiveTailToolbar" items={items} fillItemIndex={0} />;
}

export default LiveTailToolbar;
